module.exports = __webpack_public_path__ + "img/OverseaMember48.1e5a1684.jpg";